import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { FollowersService } from '../../../services/followers.service';

@Component({
  selector: 'app-follower-box',
  templateUrl: './follower-box.component.html',
  styleUrls: ['./follower-box.component.scss']
})
export class FollowerBoxComponent implements OnInit {

    constructor(private followerService: FollowersService, private authentication: AuthenticationService, private _router: Router, private common: CommonService) { }
    @Input() title: string = "Follower";
    @Input() relatedTo: string = "";
    @Input() relatedId: string = "";


    emailSuffix: string = "";

    ccAddLoading: boolean = false;
    ccDeleteLoading: boolean = false;

    newFollowerEmail: string = "";

    Followers: any[] = [];

    addFollowers(email: any) {

        email = email + this.emailSuffix;
        if (!this.common.ValidateEmail(email).valid) {
            this.common.ShowMessage('info', 'invalid email address [' + email + ']', '');
            return;
        }

        var isexisting = this.Followers.find(s => s.email == email);
        if (isexisting) {
            this.common.ShowMessage('info', 'The follower email already exists', '');
        }
        else {
            this.ccAddLoading = true;

            this.followerService.addFollower(email, this.relatedTo, this.relatedId).subscribe(
                (res: any) => {
                    if (res.success) {
                        this.loadFollowers(res.data);
                        this.newFollowerEmail = "";
                    }
                    this.ccAddLoading = false;
                },
                (err: any) => {
                    this.ccAddLoading = false;
                    console.error("addFollowers()", err);
                }
            )
        }
    }
    loadFollowers(followersArr: any[]) {
        this.Followers = [];
        for (var i = 0; i < followersArr.length; i++) {
            if (followersArr[i].user != null) {
                followersArr[i].name = followersArr[i].user.firstName + ' ' + followersArr[i].user.lastName
                followersArr[i].contactLogo = followersArr[i].user.contactLogo;
            }
            else {
                followersArr[i].name = "Unknown user";
                followersArr[i].contactLogo = "assets/images/avatar.png";
            }
            this.Followers.push(followersArr[i]);
        }
    }
    deleteFollower(followerId: any) {
        this.ccDeleteLoading = true;
        this.followerService.deleteFollower(followerId, this.relatedTo, this.relatedId).subscribe(
            (res: any) => {
                if (res.success) {
                    this.loadFollowers(res.data);
                }
                this.ccDeleteLoading = false;
            },
            (err: any) => {
                this.ccDeleteLoading = false;
                console.error("deleteFollower", err);
            }
        );
    }
    ngOnInit(): void {
        this.emailSuffix = "@" + this.authentication._authentication.userName.split("@")[1];
        this.getFollowers();
    }

    getFollowers() {
        this.followerService.getFollowers(this.relatedTo, this.relatedId).subscribe(
            (res: any) => {
                if (res.success) {
                    this.loadFollowers(res.data);
                }
            },
            (err: any) => {
                console.error("deleteFollower", err);
            }
        );
    }

}
